<script lang="ts">
  import * as _ from "lodash";
  import Icon from "@shared/svelte/Components/Icon.svelte";

  export let onClick: () => void;
  export let activeIcon: string;
  export let inactiveIcon: string;
  export let isActive: boolean;
  export let badgeText = null;
  export let badgeColor = null;
  export let dataTestId: string;
  export let text: string;

  $: linkClass = isActive ? "fizz-is-active" : "";
  $: icon = isActive ? activeIcon : inactiveIcon;
  $: iconClass = "svg-icon-" + _.toLower(icon);

  const badgeColorClass = badgeColor ? "fizz-surface-" + badgeColor : null;

</script>

<li class="">
  <a
    href={"#"}
    on:click|preventDefault={onClick}
    class="fizz-space-between {linkClass}"
    data-testid={dataTestId}
  >
    <div class="fizz-flex-row">
      <Icon extraClassNames="fizz-icon-16" type={icon} className={iconClass} />
      <span class="fizz-text-brand fizz-text-large nowrap">{text}</span>
      {#if badgeText}
        <span class={"fizz-badge " + badgeColorClass}>{badgeText}</span>
      {/if}
    </div>
  </a>
</li>
